import React from 'react'

const TodoItem = (props) => {
  return (
    <>
    <div>
      <h4 style={{color:'#7F8487'}}><b>{props.todo.title}</b></h4>
      <p style={{color:'#7F8487'}}><b>{props.todo.desc}</b></p>
      <button className="btn btn-sm btn-danger " onClick={()=>{props.onDelete(props.todo)}}><b>Delete</b></button>
    </div>
    <hr/>
    </>
  )
}

export default TodoItem
